
export class GetMessagesWithUserRequestDto {
  otherUserId: string;
  take?: number = 10;
  offset?: number = 10;
}
